module.exports = __webpack_public_path__ + "static/media/IMG_1209.f2c9e0e8.jpg";